var maps = (function () {

	var mapLoader;

	function setup() {
		mapLoader.load().then(() => {
			$('.g-map').each((i, e) => {
				let data = $(e).data();

				let map = new google.maps.Map(e,
					{
						center: { lat: data.mapLat, lng: data.mapLng },
						zoom: data.mapZoom ?? 15,
						disableDefaultUI: true,
						styles: [
							{
								"elementType": "labels.text",
								"stylers": [
									{
										"color": "#07828D"
									},
									{
										"weight": 0.1
									}
								]
							},
							
						]
					}
				);

				if (data.mapMarkerLabel != null) {
					let marker = new google.maps.Marker({
						position: { lat: data.mapLat, lng: data.mapLng },
						icon: data.mapIcon,
						map: map
					});
				}
				
			});
		});
	}

	return {
		init: function (loader) {
			mapLoader = loader;
			$(function () {
				setup();
			});
		}
	};
})();

export var maps;